import React from "react";
import styled from "styled-components";
import { useExport } from "../../../../hooks/useExport";

type IProps = {
  imgSrc: string;
  testimony: string;
  role: string;
  name: string;
};

const BeneficiaryCard = (props: IProps) => {
  const { quoteAltLeftIcon } = useExport();

  return (
    <CardWrapper>
      <ImageWrapper>
        <img
          src={props.imgSrc}
          alt="img-icon"
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "20px",
          }}
        />
        <img src={quoteAltLeftIcon} alt="quote-icon" />
      </ImageWrapper>
      <BeneficiaryDetails data-aos="fade-up" data-aos-once="true">
        <Testimony>{props.testimony}</Testimony>
        <Details>
          <Text>{props.name}</Text>
          <Role>{props.role}</Role>
        </Details>
      </BeneficiaryDetails>
    </CardWrapper>
  );
};

export default BeneficiaryCard;

const CardWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 20px;
  gap: 30px;
  width: 315px;
  height: 350px;
  background: #ffffff;
  border: 0.5px solid #908fa7;
  border-radius: 30px;
  margin-bottom: 30px;
  cursor: grab;

  &:active,
  &:focus {
    cursor: grabbing;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 30px;
  width: 275px;
  height: 80px;
`;

const BeneficiaryDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px;
  gap: 20px;
  width: 275px;
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 2px;
  margin: 0;
  width: 275px;
`;

const Testimony = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #4f4f4f;
`;

const Text = styled.p`
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
  color: #eb8145;
  padding: 0;
  margin: 0;
`;

const Role = styled.p`
  font-family: "Nunito";
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #4f4f4f;
  padding: 0;
  margin: 0;
`;
